export interface MediaEvent {
  mediaObj: Record<string, unknown>;
}
